import React from 'react';
import { Tooltip } from 'antd';

type Props = {
  title: string;
  children: React.ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right';
};

/** Visible Ant Design tooltip for ribbon inputs and icon controls. */
export const RibbonControlHint: React.FC<Props> = ({
  title,
  children,
  placement = 'top',
}) => (
  <Tooltip title={title} placement={placement} mouseEnterDelay={0.3}>
    <span className="word-ribbon-control-hint">{children}</span>
  </Tooltip>
);
